import { CrudModel } from "@core/crud/crud-model.interface";
import { Consorcista, PendingInteractionType } from "@pages/consorcios/consorcistas.service";
import { Interaction } from "./interaction.abstract";
import { CocheraConsorcista } from "./cocheras.service";


export type StatusTransfer = 'open' | 'accepted' | 'deny' | 'actionRequired';

export const TransferSteps = {
    //textos unificados (AF340): el estado dice cómo está la entrada; el botón, qué hacer
    open:{label:'Con AdminAI', step: 1, variant:'waiting'},
    accepted:{label:'Aceptado', step: 1, variant:'success'},
    deny:{label:'Rechazado', step: 1, variant:'error'},
    actionRequired:{label:'Por atender', step: 1, variant:'action'}
}

export interface ConsorcistaTransfer extends Consorcista {
  cocheras?: CocheraConsorcista[];
}


export interface Transfer extends Interaction {
  
  // texto y color que ve el usuario: el mapa *Steps de este archivo (vocabulario de AF340)
  status: StatusTransfer; 
  floor:string;
  apartment: string;
  tower?:string;
  date?:Date; // estimada de la mudanza, es opcional
  consorcistasNew:ConsorcistaTransfer[];
  maintainOwnership:boolean; // si es true, se mantienen los propietarios actuales y se agregan los nuevos como inquilinos. Si es false, se eliminan los propietarios actuales junto con los inquilinos
  //consulta o reclamo que el consorcista dejó al momento de registrar la mudanza. Se convierte en Complain/Question recién al aceptar la mudanza.
  pendingInteraction?: {
    type: PendingInteractionType;
    text: string;
  };
  //lo agrega el formulario de registro si la administración tiene activado "aceptar automáticamente". Lo cierra la función auto-close-registration.
  autoClose?: boolean;
}

export interface newTransfer extends Omit<Transfer, 'nro'|'uid' | 'createdAt' | 'status' | 'id'|'consorcioId' | 'consorcioName' | 'consorcista' | 'consorcistaId'>{};


export type Model = Transfer;
export const SUBCOLLECTION = 'transfers';